import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useStateValue } from "../../Registration/Components/ContextAPI/StateProvider";
import { image_url } from "../../api/bootapi";

export const IconModalBody = ({
  handleselectedimage,
  vehicleimages,
  getimagename,
}) => {
  return (
    <div className="row p-3">
      <img
        onClick={() => handleselectedimage("A-1", "violet")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-1_violet.png`}
      />
      <img
        onClick={() => handleselectedimage("A-2", "orange")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-2_orange.png`}
      />
      <img
        onClick={() => handleselectedimage("A-3", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-3_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-4", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-4_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-5", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-5_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-6", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-6_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-7", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-7_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-8", "purple")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-8_purple.png`}
      />
      <img
        onClick={() => handleselectedimage("A-9", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-9_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-10", "green2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-10_green2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-11", "yellow3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-11_yellow3.png`}
      />
      <img
        onClick={() => handleselectedimage("A-12", "grey2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-12_grey2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("A-13", "red2")}
        alt="vehicleicon"
        src={`${image_url}/A-13_red2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-14", "bluegrey")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-14_bluegrey.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("A-15", "green3")}
        alt="vehicleicon"
        src={`${image_url}/A-15_green3.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("A-16", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/A-16_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-17", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-17_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-18", "grey2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-18_grey2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-19", "blue3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-19_blue3.png`}
      />
      <img
        onClick={() => handleselectedimage("A-20", "red3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-20_red3.png`}
      />
      <img
        onClick={() => handleselectedimage("A-21", "blue2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-21_blue2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-22", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-22_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-23", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-23_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-24", "blue2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-24_blue2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-25", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-25_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-26", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-26_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-27", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-27_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-28", "blue2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-28_blue2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-29", "green2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-29_green2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-30", "yellow3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-30_yellow3.png`}
      />
      <img
        onClick={() => handleselectedimage("A-31", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-31_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-32", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-32_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-33", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-33_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-34", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-34_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-35", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-35_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-36", "blue3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-36_blue3.png`}
      />
      <img
        onClick={() => handleselectedimage("A-37", "green2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-37_green2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-38", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-38_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-39", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-39_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-40", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-40_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-41", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-41_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-42", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-42_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-43", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-43_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-44", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-44_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-45", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-45_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-46", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-46_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-47", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-47_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("A-48", "blue2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-48_blue2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-49", "green2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-49_green2.png`}
      />
      <img
        onClick={() => handleselectedimage("A-50", "yelow3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-50_yellow3.png`}
      />
      <img
        onClick={() => handleselectedimage("A-51", "black")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/A-51_black.png`}
      />
      <img
        onClick={() => handleselectedimage("B-1", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-1_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-2", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-2_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-3", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-3_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-4", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-4_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-5", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-5_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-6", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-6_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-7", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-7_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-8", "blue2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-8_blue2.png`}
      />
      <img
        onClick={() => handleselectedimage("B-9", "green3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-9_green3.png`}
      />
      <img
        onClick={() => handleselectedimage("B-10", "green2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-10_green2.png`}
      />
      <img
        onClick={() => handleselectedimage("B-11", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-11_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-12", "bluegrey")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-12_bluegrey.png`}
      />
      <img
        onClick={() => handleselectedimage("B-13", "blue3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-13_blue3.png`}
      />
      <img
        onClick={() => handleselectedimage("B-14", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-14_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-15", "bluegrey")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-15_bluegrey.png`}
      />
      <img
        onClick={() => handleselectedimage("B-16", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-16_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-17", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-17_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-18", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-18_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-19", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-19_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-20", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-20_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-21", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-21_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-22", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-22_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-23", "yellow3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-23_yellow3.png`}
      />
      <img
        onClick={() => handleselectedimage("B-24", "greem3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-24_green3.png`}
      />
      <img
        onClick={() => handleselectedimage("B-25", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-25_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-26", "blue1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-26_blue1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-27", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-27_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-28", "grey2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-28_grey2.png`}
      />
      <img
        onClick={() => handleselectedimage("B-29", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-29_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-30", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-30_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-31", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-31_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-32", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-32_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-33", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-33_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-34", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-34_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-35", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-35_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-36", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-36_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-37", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-37_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-38", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-38_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-39", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-39_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("B-40", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-40_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("B-41", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/B-41_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-1", "white")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-1_white.png`}
      />
      <img
        onClick={() => handleselectedimage("C-2", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-2_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-3", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-3_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-4", "green3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-4_green3.png`}
      />
      <img
        onClick={() => handleselectedimage("C-5", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-5_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-6", "yellow2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-6_yellow2.png`}
      />
      <img
        onClick={() => handleselectedimage("C-7", "grey1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-7_grey1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-8", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-8_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-9", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-9_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-10", "red3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-10_red3.png`}
      />
      <img
        onClick={() => handleselectedimage("C-11", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-11_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-12", "white")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-12_white.png`}
      />
      <img
        onClick={() => handleselectedimage("C-13", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-13_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-14", "red2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-14_red2.png`}
      />
      <img
        onClick={() => handleselectedimage("C-15", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-15_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-16", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-16_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-17", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-17_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-18", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-18_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-19", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-19_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-20", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-20_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-21", "green2")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-21_green2.png`}
      />
      <img
        onClick={() => handleselectedimage("C-22", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-22_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-23", "orange1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-23_orange1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-24", "red1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-24_red1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-25", "red3")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-25_red3.png`}
      />
      <img
        onClick={() => handleselectedimage("C-26", "white")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-26_white.png`}
      />
      <img
        onClick={() => handleselectedimage("C-27", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-27_yellow1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-28", "green1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-28_green1.png`}
      />
      <img
        onClick={() => handleselectedimage("C-29", "yellow1")}
        alt="vehicleicon"
        className="vehicle_image"
        src={`${image_url}/C-29_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-1", "yellow2")}
        alt="vehicleicon"
        src={`${image_url}/D-1_yellow2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-2", "red1")}
        alt="vehicleicon"
        src={`${image_url}/D-2_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-3", "white")}
        alt="vehicleicon"
        src={`${image_url}/D-3_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-4", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/D-4_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-5", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/D-5_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-6", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/D-6_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-7", "blue3")}
        alt="vehicleicon"
        src={`${image_url}/D-7_blue3.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-8", "white")}
        alt="vehicleicon"
        src={`${image_url}/D-8_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-9", "white")}
        alt="vehicleicon"
        src={`${image_url}/D-9_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-10", "white")}
        alt="vehicleicon"
        src={`${image_url}/D-10_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-11", "red1")}
        alt="vehicleicon"
        src={`${image_url}/D-11_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-12", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/D-12_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("D-13", "red1")}
        alt="vehicleicon"
        src={`${image_url}/D-13_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("E-1", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/E-1_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("E-2", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/E-2_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("E-3", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/E-3_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/F-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-2", "violet")}
        alt="vehicleicon"
        src={`${image_url}/F-2_violet.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-3", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/F-3_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-4", "green1")}
        alt="vehicleicon"
        src={`${image_url}/F-4_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-5", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/F-5_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-6", "red1")}
        alt="vehicleicon"
        src={`${image_url}/F-6_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-7", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/F-7_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-8", "green1")}
        alt="vehicleicon"
        src={`${image_url}/F-8_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-9", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/F-9_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-10", "white")}
        alt="vehicleicon"
        src={`${image_url}/F-10_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("F-11", "white")}
        alt="vehicleicon"
        src={`${image_url}/F-11_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/G-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-2", "pink")}
        alt="vehicleicon"
        src={`${image_url}/G-2_pink.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/G-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-4", "green1")}
        alt="vehicleicon"
        src={`${image_url}/G-4_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-5", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/G-5_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-6", "red1")}
        alt="vehicleicon"
        src={`${image_url}/G-6_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-7", "white")}
        alt="vehicleicon"
        src={`${image_url}/G-7_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-8", "red1")}
        alt="vehicleicon"
        src={`${image_url}/G-8_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-9", "violet")}
        alt="vehicleicon"
        src={`${image_url}/G-9_violet.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-10", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/G-10_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-11", "green1")}
        alt="vehicleicon"
        src={`${image_url}/G-11_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-12", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/G-12_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-13", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/G-13_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-14", "pink")}
        alt="vehicleicon"
        src={`${image_url}/G-14_pink.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-15", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/G-15_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-16", "white")}
        alt="vehicleicon"
        src={`${image_url}/G-16_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-17", "white")}
        alt="vehicleicon"
        src={`${image_url}/G-17_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-18", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/G-18_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-19", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/G-19_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-20", "green1")}
        alt="vehicleicon"
        src={`${image_url}/G-20_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-21", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/G-21_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("G-22", "green2")}
        alt="vehicleicon"
        src={`${image_url}/G-22_green2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-1", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/H-1_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-2", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/H-2_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/H-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-4", "white")}
        alt="vehicleicon"
        src={`${image_url}/H-4_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-5", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/H-5_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-6", "yellow2")}
        alt="vehicleicon"
        src={`${image_url}/H-6_yellow2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-7", "white")}
        alt="vehicleicon"
        src={`${image_url}/H-7_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-8", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/H-8_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("H-9", "white")}
        alt="vehicleicon"
        src={`${image_url}/H-9_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("K-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/K-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("K-2", "red1")}
        alt="vehicleicon"
        src={`${image_url}/K-2_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/L-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-2", "violet")}
        alt="vehicleicon"
        src={`${image_url}/L-2_violet.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/L-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-4", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/L-4_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-5", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/L-5_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-6", "green1")}
        alt="vehicleicon"
        src={`${image_url}/L-6_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-7", "red1")}
        alt="vehicleicon"
        src={`${image_url}/L-7_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-8", "violet")}
        alt="vehicleicon"
        src={`${image_url}/L-8_violet.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-9", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/L-9_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-10", "green1")}
        alt="vehicleicon"
        src={`${image_url}/L-10_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-11", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/L-11_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-12", "red1")}
        alt="vehicleicon"
        src={`${image_url}/L-12_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-13", "pink")}
        alt="vehicleicon"
        src={`${image_url}/L-13_pink.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-14", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/L-14_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-15", "green1")}
        alt="vehicleicon"
        src={`${image_url}/L-15_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-16", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/L-16_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-17", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/L-17_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-18", "white")}
        alt="vehicleicon"
        src={`${image_url}/L-18_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-19", "grey1")}
        alt="vehicleicon"
        src={`${image_url}/L-19_grey1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-20", "white")}
        alt="vehicleicon"
        src={`${image_url}/L-20_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("L-21", "black")}
        alt="vehicleicon"
        src={`${image_url}/L-21_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-1", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/M-1_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-2", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/M-2_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-3", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-3_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-4", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-4_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-5", "yellow2")}
        alt="vehicleicon"
        src={`${image_url}/M-5_yellow2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-6", "yellow2")}
        alt="vehicleicon"
        src={`${image_url}/M-6_yellow2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-7", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-7_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-8", "grey1")}
        alt="vehicleicon"
        src={`${image_url}/M-8_grey1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-9", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-9_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-10", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-10_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-11", "yellow2")}
        alt="vehicleicon"
        src={`${image_url}/M-11_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-12", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-12_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-13", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-13_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-14", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/M-14_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-15", "black")}
        alt="vehicleicon"
        src={`${image_url}/M-15_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-16", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/M-16_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-17", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/M-17_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-18", "orange1")}
        alt="vehicleicon"
        src={`${image_url}/M-18_orange1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-19", "red1")}
        alt="vehicleicon"
        src={`${image_url}/M-19_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-20", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/M-20_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("M-21", "green1")}
        alt="vehicleicon"
        src={`${image_url}/M-21_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("N-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/N-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("N-2", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/N-2_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("N-3", "green1")}
        alt="vehicleicon"
        src={`${image_url}/N-3_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("N-4", "red1")}
        alt="vehicleicon"
        src={`${image_url}/N-4_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("N-5", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/N-5_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("N-6", "green2")}
        alt="vehicleicon"
        src={`${image_url}/N-6_green2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("O-1", "white")}
        alt="vehicleicon"
        src={`${image_url}/O-1_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("O-2", "red1")}
        alt="vehicleicon"
        src={`${image_url}/O-2_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("O-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/O-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("P-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/P-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("P-2", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/P-2_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("P-3", "green1")}
        alt="vehicleicon"
        src={`${image_url}/P-3_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("P-4", "red1")}
        alt="vehicleicon"
        src={`${image_url}/P-4_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("P-5", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/P-5_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("P-6", "green1")}
        alt="vehicleicon"
        src={`${image_url}/P-6_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Q-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/Q-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Q-2", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/Q-2_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Q-3", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/Q-3_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("R-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/R-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("R-2", "red2")}
        alt="vehicleicon"
        src={`${image_url}/R-2_red2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("R-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/R-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("R-4", "green1")}
        alt="vehicleicon"
        src={`${image_url}/R-4_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("R-5", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/R-5_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("R-6", "white")}
        alt="vehicleicon"
        src={`${image_url}/R-6_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-1", "white")}
        alt="vehicleicon"
        src={`${image_url}/T-1_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-2", "red1")}
        alt="vehicleicon"
        src={`${image_url}/T-2_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/T-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-4", "green1")}
        alt="vehicleicon"
        src={`${image_url}/T-4_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-5", "green2")}
        alt="vehicleicon"
        src={`${image_url}/T-5_green2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-6", "white")}
        alt="vehicleicon"
        src={`${image_url}/T-6_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("T-7", "black")}
        alt="vehicleicon"
        src={`${image_url}/T-7_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("V-1", "white")}
        alt="vehicleicon"
        src={`${image_url}/V-1_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("V-2", "red1")}
        alt="vehicleicon"
        src={`${image_url}/V-2_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("V-3", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/V-3_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("V-4", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/V-4_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("V-5", "green1")}
        alt="vehicleicon"
        src={`${image_url}/V-5_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("W-1", "red1")}
        alt="vehicleicon"
        src={`${image_url}/W-1_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("W-2", "white")}
        alt="vehicleicon"
        src={`${image_url}/W-2_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("W-3", "green1")}
        alt="vehicleicon"
        src={`${image_url}/W-3_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("X-1", "black")}
        alt="vehicleicon"
        src={`${image_url}/X-1_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Y-1", "grey1")}
        alt="vehicleicon"
        src={`${image_url}/Y-1_grey1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Y-2", "grey2")}
        alt="vehicleicon"
        src={`${image_url}/Y-2_grey2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Y-3", "white")}
        alt="vehicleicon"
        src={`${image_url}/Y-3_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Y-4", "grey2")}
        alt="vehicleicon"
        src={`${image_url}/Y-4_grey2.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Y-5", "grey1")}
        alt="vehicleicon"
        src={`${image_url}/Y-5_grey1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Y-6", "yellow1")}
        alt="vehicleicon"
        src={`${image_url}/Y-6_yellow1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-1", "violet")}
        alt="vehicleicon"
        src={`${image_url}/Z-1_violet.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-2", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-2_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-3", "green1")}
        alt="vehicleicon"
        src={`${image_url}/Z-3_green1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-4", "pink")}
        alt="vehicleicon"
        src={`${image_url}/Z-4_pink.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-5", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/Z-5_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-6", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-6_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-7", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-7_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-8", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/Z-8_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-9", "pink")}
        alt="vehicleicon"
        src={`${image_url}/Z-9_pink.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-10", "pink")}
        alt="vehicleicon"
        src={`${image_url}/Z-10_pink.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-11", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-11_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-12", "red1")}
        alt="vehicleicon"
        src={`${image_url}/Z-12_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-13", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-13_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-14", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/Z-14_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-15", "blue1")}
        alt="vehicleicon"
        src={`${image_url}/Z-15_blue1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-16", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-16_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-17", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-17_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-18", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-18_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-19", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-19_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-20", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-20_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-21", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-21_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-22", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-22_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-23", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-23_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-24", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-24_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-25", "red1")}
        alt="vehicleicon"
        src={`${image_url}/Z-25_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-26", "red1")}
        alt="vehicleicon"
        src={`${image_url}/Z-26_red1.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-27", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-27_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-28", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-28_black.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-29", "white")}
        alt="vehicleicon"
        src={`${image_url}/Z-29_white.png`}
      />
      <img
        className="vehicle_image"
        onClick={() => handleselectedimage("Z-30", "black")}
        alt="vehicleicon"
        src={`${image_url}/Z-30_black.png`}
      />
      {vehicleimages.map((image, i) => (
        <React.Fragment key={i}>
          {image["length"].map((item, index) => (
            <React.Fragment key={index}>
              <img
                onClick={() => handleselectedimage(image["value"], index)}
                style={{
                  width: "20px",
                  cursor: "pointer",
                  margin: "2px",
                }}
                alt="vehicleicon"
                src={getimagename(image["value"], index)}
              />
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
const DeviceSettingGPSRight = () => {
  const [{ devicesettinggps, vehicleimages, vehicle_colors_obj2 }, dispatch] =
    useStateValue();
  // const [color, setcolor] = useState();
  const [colormodal, setcolormodal] = useState(false);
  const handlecolormodal = () => setcolormodal(!colormodal);
  // useEffect(() => {
  //   /* eslint-disable react-hooks/exhaustive-deps */
  //   checkcolor();
  // }, [devicesettinggps]);

  // const checkcolor = () => {
  //   for (let i = 0; i < vehicle_colors.length; i++) {
  //     if (vehicle_colors[i].text === devicesettinggps.vehicle_color) {
  //       setcolor(vehicle_colors[i].value);
  //     }
  //   }
  // };

  const callreducer = (val) => {
    dispatch({
      type: "ADD_TO_DEVICESETTINGS_GPS",
      devicesetting: val,
    });
  };
  const inputEvent = (e) => {
    let name = e.target.name;
    devicesettinggps[`${name}`] = e.target.checked;
    callreducer(devicesettinggps);
  };
  // const inputEvent2 = (e) => {
  //   let name = e.target.name;
  //   devicesettinggps[`${name}`] = e.target.value;
  //   callreducer(devicesettinggps);
  // };
  const getimagename = (value, i) => {
    return `${image_url}/${value}_${vehicle_colors_obj2[i]["text"]}.png`;
  };
  const handleselectedimage = (type, color) => {
    handlecolormodal();
    devicesettinggps.vehicle_type = type;
    if (
      type === "car" ||
      type === "bus" ||
      type === "marker" ||
      type === "minibus" ||
      type === "minitruck" ||
      type === "truck"
    ) {
      devicesettinggps.vehicle_color = vehicle_colors_obj2[color]["text"];
    } else {
      devicesettinggps.vehicle_color = color;
    }
    callreducer(devicesettinggps);
  };
  return (
    <div style={{ marginLeft: "20px" }}>
      <div>
        <div className="row marginrow">
          <div className="col-md-4 textalignleft">
            <strong>Current Device Frequency:</strong>
          </div>
          <div className="col-md-8">
            <p className="devicesetingright_headerp">
              {devicesettinggps.device_reporting_frequency_desc}
            </p>
          </div>
        </div>
      </div>
      <hr className="devicesetting_margin" />
      <div>
        <h5 className="text-center">Device Information to show</h5>
        <hr />
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Tracker Speed:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_speed"
                checked={devicesettinggps.show_speed}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Tracker Odometer:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_mileage"
                checked={devicesettinggps.show_mileage}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Tracker Battery:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_voltage"
                checked={devicesettinggps.show_voltage}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
        <div className="row marginrow">
          <div className="col-md-5 textalignleft devicesetting_alert">
            <strong>Show Tracker Location:</strong>
          </div>
          <div className="col-md-7">
            <label className="toggleswitch">
              <input
                type="checkbox"
                name="show_location"
                checked={devicesettinggps.show_location}
                onChange={inputEvent}
              />
              <span className="toggleslider toggleround"></span>
            </label>
          </div>
        </div>
      </div>

      <div>
        <h5 className="text-center">Tracker Skins</h5>
        <hr />
        <div>
          <div className="row marginrow">
            <div className="col-md-4 textalignleft">
              <strong>Tracker</strong>
            </div>
            <div className="col-md-8 devicesettingleft">
              <img
                alt="currentvehicle"
                style={{ maxHeight: "40px" }}
                src={`${image_url}/${devicesettinggps.vehicle_type}_${devicesettinggps.vehicle_color}.png`}
              />
              <button
                className="btn btn-primary ml-2"
                onClick={handlecolormodal}
              >
                Choose Icon
              </button>
              {/* <select
                value={devicesettinggps.vehicle_type}
                name="vehicle_type"
                onChange={inputEvent2}
                className="form-control devicesettingleft_select"
              >
                <option value="marker">Marker</option>
                <option value="car">Car</option>
                <option value="bus">Bus</option>
                <option value="minibus">Mini Bus</option>
                <option value="truck">Truck</option>
                <option value="minitruck">Mini Truck</option>
              </select> */}
            </div>
          </div>
          {/* <div className="row marginrow">
            <div className="col-md-4 textalignleft">
              <strong>Vehicle Color:</strong>
            </div>
            <div className="col-md-8" onClick={handlecolormodal}>
              <input
                style={{
                  backgroundColor: color,
                  width: "100%",
                }}
                readOnly
              />
            </div>
          </div> */}
        </div>
      </div>
      <Modal
        size="lg"
        show={colormodal}
        onHide={() => handlecolormodal()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Pick Tracker Icon!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <IconModalBody
            getimagename={getimagename}
            vehicleimages={vehicleimages}
            handleselectedimage={handleselectedimage}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DeviceSettingGPSRight;
